<template>
  <!-- 本组件为：折线图，如锂电池走势图里的重启次数折线图 -->
  <div :style="{height:height,width:width}" style="position:relative;">
    <p v-show="columnLineNoData" style="position: absolute;width: 100%;top: 130px;z-index: 999;text-align: center;">{{ $t("yhubReport.Nodata") }}</p>
    <div ref="lineChart" :class="className" :style="{height:height,width:width}" />
  </div>
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './resize'
import { getDateAndHour } from '@/utils/updateTime.js'
import i18n from '@/i18n'
var myColor = [
  '#30c7c9', '#b6a2de', '#59b1ef', '#ffb980',
  '#d87980', '#8c98b3', '#e5ce2c', '#97b552',
  '#996666', '#cc6699', '#339999', '#9966cc',
  '#6699cc', '#ff9933', '#cc6666', '#666699'
]
var xData = []; var yData = []
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    lineDate: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null,
      columnLineNoData: false
    }
  },
  watch: {
    lineDate: {
      handler(newValue, oldValue) {
        this.lineDate = newValue // 把新值赋值给我们的属性数据
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
    })
    setTimeout(() => {
      this.initChart()
    }, 500)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      // xData,yData
      xData = []
      yData = []
      // console.log(this.lineDate)
      if (this.lineDate.length == 0) {
        this.columnLineNoData = true
      } else {
        this.columnLineNoData = false
      }
      this.lineDate.forEach(v => {
        xData.push(getDateAndHour(v.summaryTime, 'onlyMonthAndDay'))
        yData.push(v.rebootCount)
      })
      this.chart = echarts.init(this.$refs.lineChart, 'macarons')
      var option = {
        title: {
          top: '0',
          left: 'center',
          text: i18n.t('allDeviceDetail.statisticsCount'), // '设备重启次数统计',
          textStyle: {
            align: 'center',
            color: '#1990fc',
            fontSize: 18
          }

        },
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          formatter: function(param, ticket, callback) {
            var htmlStr = ''
            htmlStr += '<div>'
            // 圆点
            var radiuSpan1 = '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:'
            var radiuSpan2 = ';"></span>'
            htmlStr += getDateAndHour(param[0].data.summaryTime, 'noTime') + '<br/>'
            var isOnline = i18n.t('allDeviceDetail.Connected')// '已联网'
            isOnline = param[0].data.rebootCount == 0 ? i18n.t('allDeviceDetail.NotConnected') : i18n.t('allDeviceDetail.Connected')// '未联网' : '已联网'
            htmlStr += radiuSpan1 + myColor[1] + radiuSpan2 + i18n.t('allDeviceDetail.networking') + '：' + isOnline + '<br/>'
            htmlStr += radiuSpan1 + myColor[0] + radiuSpan2 + i18n.t('allDeviceDetail.NumberRestarts') + '：' + param[0].data.rebootCount + i18n.t('allDeviceDetail.Times') + ' <br/>' // '重启次数'
            htmlStr += '</div>'
            return htmlStr
          }
        },
        dataZoom: [{
          type: 'slider',
          show: true,
          height: 30,
          left: '5%',
          right: '5%',
          bottom: '2%',
          start: 0,
          end: 100,
          textStyle: {
            color: '#1990fc',
            fontSize: 11
          }
        }],
        grid: {
          right: '5%',
          bottom: '15%',
          left: '5%',
          top: '50px',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: xData,
          name: i18n.t('allDeviceDetail.time'), // '时间',
          nameTextStyle: {
            color: '#1990fc'
          },
          axisLine: {
            lineStyle: {
              color: '#1990fc'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#1990fc',
              fontSize: 12
            }
            // interval:0,
            // rotate:30
          }
        }],
        yAxis: [{
          type: 'value',
          name: i18n.t('allDeviceDetail.NumberTimes'), // '次数',
          nameTextStyle: {
            color: '#1990fc'
          },
          position: 'center',
          axisLine: {
            lineStyle: {
              color: '#1990fc'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#eeeeee'
            }
          },
          axisLabel: {
            color: '#1990fc',
            fontSize: 12
          }
        }],
        series: [{
          name: '',
          type: 'line',
          yAxisIndex: 0,
          symbolSize: 12,
          itemStyle: {
            normal: {
              color: '#1990fc'
            }
          },
          smooth: false,
          // data: yData
          data: this.lineDate
        }
        ]
      }

      this.chart.setOption(option, false)
    }
  }
}
</script>
